import {FirstPage, LastPage} from "@mui/icons-material";
import React from "react";
import {ToggleButton} from "@mui/material";
import shortid from "shortid";


class PagerButtonBuilder {


  static buildButton(actualPage, buttonTitle) {
    actualPage = actualPage.toString();
    return (<ToggleButton sx={{minWidth: 50}} value={actualPage} key={shortid()}>{buttonTitle}</ToggleButton>);
  };

  static buildButtonLessEqual10 = (numOfPages, actualPage) => {
    let buttons = [];
    for (let i = 1; i <= numOfPages; i++) {
      const isActive = actualPage === i;
      buttons.push(this.buildButton(i, i, isActive));
    }
    return buttons;
  };

  static buildButtonGrater10 = (numOfPages, actualPage) => {
    let buttons = [];
    let tempPageIndex = 0;
    // first
    buttons.push(this.buildButton(1, <FirstPage/>));

    // prev_1_2    -1/2
    let pageIndex = actualPage - Math.floor(numOfPages / 2);
    if (pageIndex >= 1) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // prev_1_10   -1/10
    pageIndex = actualPage - Math.floor(numOfPages / 10);
    if (pageIndex >= 1 && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // prev_10     -10
    pageIndex = actualPage - 10;
    if (pageIndex >= 1 && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // prev_1      -1
    pageIndex = actualPage - 1;
    if (pageIndex >= 1 && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // actualPage
    pageIndex = actualPage;
    if (actualPage > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(actualPage, actualPage));
    }

    // next_1      +1
    pageIndex = actualPage + 1;
    if (pageIndex <= numOfPages && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // next_10     +10
    pageIndex = actualPage + 10;
    if (pageIndex <= numOfPages && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // next_1_10   +1/10
    pageIndex = actualPage + Math.floor(numOfPages / 10);
    if (pageIndex <= numOfPages && pageIndex > tempPageIndex) {
      tempPageIndex = pageIndex;
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // next_1_2    +1/2
    pageIndex = actualPage + Math.floor(numOfPages / 2);
    if (pageIndex <= numOfPages && pageIndex > tempPageIndex) {
      buttons.push(this.buildButton(pageIndex, pageIndex));
    }

    // last
    buttons.push(this.buildButton(numOfPages, <LastPage/>));

    return buttons;
  };
}

export default PagerButtonBuilder;